import { Flex, Box } from '@chakra-ui/react';

/**
 * Range selector (1W / 1M / 3M / YTD / 1Y / ALL), as Copilot draws it: a row of
 * 48 × 28 pills with no track, the chosen range filled.
 * Pure component — receives value + onChange. Reusable across redesigned sections.
 * `pillProps` restyles every pill (the phone's account sheet makes them
 * 44px taps that share the row); the row then spans its container.
 */
export default function RangeSelector({
  value,
  onChange,
  ranges = ['1W', '1M', '3M', 'YTD', '1Y', 'ALL'],
  pillProps,
}) {
  return (
    <Flex justify="center">
      <Flex
        role="group"
        gap="8px"
        w={pillProps ? '100%' : undefined}
      >
        {ranges.map(r => {
          const active = value === r;
          return (
            <Box
              key={r}
              as="button"
              type="button"
              aria-pressed={active}
              onClick={() => onChange(r)}
              minW="48px"
              h="28px"
              px={2}
              borderRadius="full"
              fontSize="13px"
              fontWeight={600}
              bg={active ? 'redesign.bg.accent' : 'transparent'}
              color={active ? 'redesign.heading' : 'redesign.text.muted'}
              transition="all 0.15s"
              _hover={!active ? { color: 'redesign.heading' } : {}}
              {...pillProps}
            >
              {r}
            </Box>
          );
        })}
      </Flex>
    </Flex>
  );
}
